import { cva } from 'class-variance-authority'

const textVariants = cva('font-body', {
  variants: {
    variant: {
      label: 'text-20 leading-40 font-500 tracking-20',
      body1: 'text-30 leading-40 font-400 tracking-20',
      body2: 'text-20 leading-30 font-400 tracking-20',
      caption: 'text-10 leading-20 font-400 tracking-20',
    },
    // Override only. Concatenated after `variant`, so `cn()` keeps this weight.
    weight: {
      regular: 'font-400',
      medium: 'font-500',
      semibold: 'font-600',
    },
  },
  defaultVariants: {
    variant: 'body1',
  },
})

export { textVariants }
